import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'applicationtype'
})
export class ApplicationtypePipe implements PipeTransform {

  transform(value: number, ...args: unknown[]): string {
    switch (value) {
      case 0:
        return 'تقديم مباشر';
      case 1:
        return 'تقديم خارجي';
      default:
        return 'غير معروف';
    }
  }

}

